export const BASE_API_URL: string | undefined = import.meta.env.VITE_API_URL;
export const SOCKET_BASE_URL: string | undefined = import.meta.env
  .VITE_SOCKET_BASE_URL;

export type Endpoint = {
  url: string;
};
